module.exports = __webpack_public_path__ + "img/Guyana.ec98b01f.svg";